import { useState } from 'react'
import styled from 'styled-components'

const Button = styled.div`
    background: none;
    color: var(--clr-secondary);
    padding: 15px 35px;
    border: 3px solid var(--bg-tertiary);
    &:hover {
        background: white;
        color: $primaryBackground;
        border: 3px solid var(--bg-primary);
        cursor: pointer;
        user-select: none;
    }
    h4{
        font-size: 13px;
    }
    img{
        width: 35px;
    }
    &.hide {
        border-radius: 15px;
    }
    span.accordion-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        h4 {
            font-weight: 500;
            font-size: 18px;
            line-height: 27px;
        }
    }
    @media (max-width: 600px) {
        margin: 0 auto;
        padding: .5em;
        padding-left: 1em;
        width: 90%;
        font-size: 20px;
        img{
            width: 25px;
        }
    }
`
const List = styled.ol`
    background: none;
    color: var(--clr-secondary);
    padding: 15px 35px;
    margin-bottom: 25px;
    border: 3px solid var(--bg-tertiary);
    border-top: none;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    &.display-block {
        display: block;
    }
    &.display-none {
        display: none;
    }
    @media (max-width: 600px) {
        margin: 0 auto;
        width: 90%;
    }
`

type Props = {
  header:string;
  children:any;
}

const Accordion = ({ header, children }: Props) => {
  const [hideList, setHide] = useState(true)
  return (
    <div className='w-full'>
        <Button
            className={`
              component-accordion
              ${hideList ? 'hide' : ''}
              w-full
            `}
            onClick={() => setHide(!hideList)}
            style={{ background: hideList ? '#FFF' : '#F8F8F8' }}
        >
            <span className="accordion-container">
                <h4 className="text-left"> {header} </h4>
                <img src={`/media/elements/${hideList ? 'plus' : 'minus'}.png`} alt="Expand" />
            </span>
        </Button>
        <List className={`accordion-list display-${hideList ? 'none' : 'block'}`}>
            {children}
        </List>
    </div>
  )
}

export default Accordion
